module.exports = __webpack_public_path__ + "app/assets/images/man10-b6fb1efcae52c19e9e4fdc9a9211b30f.jpg";